import React from 'react';
import {Row, Col, Form,Button, Card} from 'react-bootstrap';
import './Reports.css'
import adduser from '../images/add-new-user-svgrepo-com@2x.png';
const CreateUser=()=>{
  return(
    <div>
    <div className="Report">
    <p>Create User</p>
    </div>
    <div style={{textAlign:'center', paddingTop:5}}>
       <div style={{height:150, width:150, 
            background:'linear-gradient(#3D4389,#0D0E16)', 
            display:'inline-flex', alignItems:'center', justifyContent:'center', 
          borderRadius:'50%'}}>
            <img  src={adduser} style={{
              height:100,
              padding:10
            }}/>
       </div>
    </div>
    <Form style={{paddingTop:'0px',}} 
    // onSubmit={handleSubmit({name},{email},{mobile},{role},{scheme},{priority})}

>
<Row style={{marginTop:'30px'}} >
    <Form.Label column="sm" lg={1} style={{color:'white',marginTop:'10px'}}>
      Name
    </Form.Label>
    <Col>
      <Form.Control size="md" type="text" required placeholder="Name"  style={{marginTop:'10px'}} 
    onChange={e =>{}}
/>
    </Col>
    <Form.Label column="sm" lg={1} style={{color:'white',marginTop:'10px'}}>
      Email
    </Form.Label>
    <Col>
    <Form.Control size="md" type="text" required placeholder="Email"  style={{marginTop:'10px'}} 
/>
      
    </Col>
  </Row>
  <Row style={{marginTop:'30px'}}>
    <Form.Label type="text" column="sm" lg={1} style={{color:'white',marginTop:'10px'}} required>
      Mobile
    </Form.Label>
    <Col>
      <Form.Control size="md" type="text" placeholder="Mobile" style={{marginTop:'10px'}} 
      required/>
    </Col>
    <Form.Label column="sm" lg={1} style={{color:'white',marginTop:'10px'}}>
      Role
    </Form.Label>
    <Col>
      <select
      style={{
          appearance:'auto'
      }} className="form-control" id="exampleFormControlSelect1">
      <option disabled="disabled">Select Role</option>
      <option value='Corporate Manager'>Corporate Manager</option>
      <option value='Corporate User'>Corporate User</option>
      <option value='Backend Executive'>Backend Executive</option>
      <option value='Filed Executive'>Filed Executive</option>
    </select>
    </Col>
  </Row>
  <Row style={{marginTop:'30px'}}>
    <Form.Label column="sm" lg={1} style={{color:'white'}}>
      Scheme
    </Form.Label>
    <Col>
      <Form.Control size="md" type="text" placeholder="Sceme" style={{marginTop:'10px'}} 
      required/>
    </Col>
    <Form.Label column="sm" lg={1} style={{color:'white',marginTop:'10px'}}>
      Priority
    </Form.Label>
    <Col>
      <Form.Control  size="sm" type="text" placeholder="Prioritty" style={{marginTop:'10px'}} 
        required/>
    </Col>
  </Row>
  <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
    <Button type="submit" variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Save</Button>
  </div>
</Form>
  
  
  
    </div>
  )
}
export default CreateUser;